import { render, staticRenderFns } from "./AmendReport.vue?vue&type=template&id=88e24cb6&"
import script from "./AmendReport.vue?vue&type=script&lang=js&"
export * from "./AmendReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports